import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { CheckCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";
import React from "react";

export default function PlanPaymentResultModal({ open, onClose, action }) {
  const getData = () => {
    if (action === "downgrade")
      return {
        title: "Downgrade Successful",
        description:
          "No payment was required at this time. Thank you for your business!",
      };

    if (action === "cancel")
      return {
        title: "Cancel Plan Successful",
        description:
          "Please feel free to reach out to help@supportmagic.ai if there’s anything we can do to help you through your journey.",
      };

    if (action === "renew")
      return {
        title: "Renew Successful",
        description:
          "Your payment has successfully processed. Thank you for your business!",
      };

    return {
      title: "Upgrade Successful",
      description:
        "Your payment has successfully processed. Thank you for your business!",
    };
  };

  const data = getData();

  return (
    <Dialog open={open} onClose={onClose} className="relative z-[9999]">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/30 backdrop-blur-sm transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-sm sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div>
              <div className="flex items-start gap-6 justify-between">
                <div className="p-3 rounded-full bg-green-100">
                  <CheckCircleIcon
                    aria-hidden="true"
                    className="size-8 text-green-600"
                  />
                </div>

                <button type="button" onClick={onClose}>
                  <XMarkIcon className="size-6 text-gray-400 hover:text-gray-600" />
                </button>
              </div>

              <div className="mt-3 sm:mt-5">
                <DialogTitle
                  as="h3"
                  className="text-base font-semibold text-gray-900"
                >
                  {data?.title}
                </DialogTitle>

                <p className="text-sm text-gray-500">{data?.description}</p>
              </div>
            </div>
            <div className="mt-5 sm:mt-6">
              <button
                type="button"
                onClick={onClose}
                className="flex w-full justify-center rounded-md bg-primary px-3 py-2 text-sm/6 font-semibold text-white shadow-sm hover:bg-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:bg-primary"
              >
                Ok
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
